export const TEXT_FIELD = 'textField'
export const CHECK_MY_PAPER = 'checkMyPaper'
export const MY_COMPUTER = 'myComputer'
export const GDRIVE = 'gdrive'
